// Entry point for the build script in your package.json

import "@hotwired/turbo-rails"
import "./controllers"


// document.addEventListener('turbo:submit-end', function(event) {
//   const response = event.detail.fetchResponse.response;
//   if (!response.ok && response.status >= 500) {
//
//     // Replace current page/body with error response
//     response.text().then(data => { document.documentElement.innerHTML = data })
//     // document.documentElement.innerHTML = response.text();
//
//     event.target.reset();
//     event.preventDefault();
//     //  Event.preventDefault()
//     //  Turbo.visit(window.location.href, { action: 'replace' });
//   }
// });

document.addEventListener('turbo:before-fetch-response', (event) => {
  console.log(event.detail.fetchResponse.response)
  const response = event.detail.fetchResponse.response
  const status = response.status

  if (status >= 400 && status != 422) {
    event.preventDefault();

    let turboErrorContainer = document.getElementById("turbo_error_container")
    if (!turbo_error_container) {
      turboErrorContainer = document.createElement("div")
      turboErrorContainter.id = "turbo_error_container"

      const main = document.queryselector('main') || document.body
      main.prepend(turboErrorContainer);
    }
    turboErrorContainer.innerHTML =
      `<details open>
        <summary>Error Status: ${status}</summary>
        <iframe class='w-full h-dvh'></iframe>
      </details>`
    turboErrorContainer.classList.remove("hidden")
    let detailsElement = turboErrorContainer.children[0]
    let iframe = detailsElement.children[1]

    response.text().then(data => {
      //   const bodyMatch = data.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
      //   const bodyContent = bodyMatch ? bodyMatch[1] : fullHtml;
      //   const tempDiv = document.createElement('div');
      //   tempDiv.innerHTML = data;
      //   iframe.innerHTML = tempDiv.querySelector('body')?.innerHTML || data;

      iframe.contentDocument.open()
      iframe.contentDocument.write(data)
      iframe.contentDocument.close()

      // const popup = window.open()
      // popup.document.open()
      // popup.document.write(data)
      // popup.document.close()
      // popup.focus()

    })
    // Form remains as-is, no page refresh or frame update
  }
});

// HACK: refresh sidecoat components on screen udpate (better is to have stimulus coponents)
document.addEventListener("turbo:render", (event) => {
  console.log(window.basecoat)
  if (window.basecoat) {
    window.basecoat.initAll()
  }
});
